import apollo from 'apollo';

import { installedAppStatusQuery } from 'queries';
import { AsyncActionHandler } from 'action-handler';
import { handleFetchError } from 'action-utils';
import { reducer as permissionsReducer } from 'actions/registry/update-permissions';
import { updatePendingFromInstalledReducer } from 'actions/registry/set-pending-app-install-status';

export const reducer = (state, { appStatus }) => {
  if (!appStatus) {
    return state;
  }

  const installedApps = {
    ...state.installedApps,
    [appStatus.appId]: appStatus
  };

  return {
    ...permissionsReducer(state, appStatus),
    ...updatePendingFromInstalledReducer(state, installedApps),
    installedApps
  };
};

export default new AsyncActionHandler({
  name: 'fetch_installed_app_status',
  handler(id) {
    return async (dispatch, getState) => {
      const {
        gallery: {
          deviceInfo: { wireId }
        }
      } = getState();
      let appStatus;
      try {
        const { data } = await apollo.query({
          query: installedAppStatusQuery,
          fetchPolicy: 'network-only',
          variables: {
            id,
            wireId
          }
        });
        appStatus = data.appStatus;
      } catch (error) {
        return handleFetchError(error);
      }

      if (!appStatus) {
        return;
      }

      return {
        appStatus
      };
    };
  },
  reduce: reducer
});
